import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqData } from '../data/mock';

// FAQPage JSON-LD — exposes the homepage FAQ to Google rich results,
// AI Overviews, and answer-engine retrieval. Built from the same
// faqData source the visible accordion renders.
const buildFaqPageJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: f.answer,
    },
  })),
});

const FAQ = () => {
  const faqJsonLd = buildFaqPageJsonLd(faqData);

  // Imperatively inject/remove JSON-LD into <head> so React's fiber
  // deletion path on route unmount never sees it. Otherwise React tries
  // to removeChild the <script> node from its virtual parent even
  // though the browser had already relocated it — see SEO.jsx for the
  // longer explanation.
  useEffect(() => {
    const id = 'faq-page-jsonld';
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(faqJsonLd);
    return () => {
      const node = document.getElementById(id);
      if (node && node.parentNode) node.parentNode.removeChild(node);
    };
  }, [JSON.stringify(faqJsonLd)]);

  return (
    <section id="faq" className="faq-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Common Questions</h2>
          <p className="section-subtitle">
            Everything you need to know before your visit
          </p>
        </div>

        <div className="faq-content">
          <Accordion type="single" collapsible className="faq-accordion">
            {faqData.map((faq, index) => (
              <AccordionItem key={faq.question} value={`item-${index}`}>
                <AccordionTrigger className="faq-question">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="faq-answer">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
